import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-fbe121d8"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["src"]

import { ref, computed } from 'vue'
import { isD2C, isJA, isKO, isEN } from '@/store'

export default /*#__PURE__*/_defineComponent({
  emits: ['close'],
  setup(__props, { emit }) {

const shop1cJP = require('@/assets/image/guide/shopGuide/shopGuide1-c.jpg')
const shop2cJP = require('@/assets/image/guide/shopGuide/shopGuide2-c.jpg')
const shop1bJP = require('@/assets/image/guide/shopGuide/shopGuide1-b.jpg')
const shop2bJP = require('@/assets/image/guide/shopGuide/shopGuide2-b.jpg')

const shop1cKR = require('@/assets/image/guide/shopGuide/shopGuide_2c_kr_1.jpg')
const shop2cKR = require('@/assets/image/guide/shopGuide/shopGuide_2c_kr_2.jpg')
const shop1bKR = require('@/assets/image/guide/shopGuide/shopGuide_2b_kr_1.jpg')
const shop2bKR = require('@/assets/image/guide/shopGuide/shopGuide_2b_kr_2.jpg')

const shop1cEN = 'https://static-s.theckb.com/BusinessMarket/Client/guide/shopGuide_en_1.jpg'
const shop2cEN = 'https://static-s.theckb.com/BusinessMarket/Client/guide/shopGuide_en_2.jpg'
const csl = ref()

const visible = ref(true)

// const carouselList: any = ref([])
// carouselList.value = isD2C() ? [
//   require('@/assets/image/guide/shopGuide/shopGuide1-c.jpg'),
//   require('@/assets/image/guide/shopGuide/shopGuide2-c.jpg')
// ] : [
//   require('@/assets/image/guide/shopGuide/shopGuide1-b.jpg'),
//   require('@/assets/image/guide/shopGuide/shopGuide2-b.jpg')
// ]
const carouselList = computed(() => {
  console.log(isJA())
  if (isJA()) {
    return isD2C() ? [shop1cJP, shop2cJP] : [shop1bJP, shop2bJP]
  }
  if (isKO()) {
    return isD2C() ? [shop1cKR, shop2cKR] : [shop1bKR, shop2bKR]
  }
  return [shop1cEN, shop2cEN]
})

return (_ctx: any,_cache: any) => {
  const _component_el_carousel_item = _resolveComponent("el-carousel-item")!
  const _component_el_carousel = _resolveComponent("el-carousel")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    "model-value": visible.value,
    width: "1200px",
    top: "10vh",
    onClosed: _cache[2] || (_cache[2] = ($event: any) => (emit('close'))),
    "close-on-click-modal": false
  }, {
    default: _withCtx(() => [
      _createVNode(_component_el_carousel, {
        ref: (_value, _refs) => {
          _refs['csl'] = _value
          csl.value = _value
        },
        height: "675px",
        arrow: "never",
        trigger: "click",
        autoplay: false
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(carouselList), (item, k) => {
            return (_openBlock(), _createBlock(_component_el_carousel_item, { key: k }, {
              default: _withCtx(() => [
                _createElementVNode("img", {
                  referrerPolicy: "no-referrer",
                  class: "",
                  src: item
                }, null, 8, _hoisted_1)
              ]),
              _: 2
            }, 1024))
          }), 128)),
          _createElementVNode("div", {
            class: "abs arrow aw-lf btn",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (csl.value.prev()))
          }),
          _createElementVNode("div", {
            class: "abs arrow aw-rt btn",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (csl.value.next()))
          })
        ]),
        _: 1
      }, 512)
    ]),
    _: 1
  }, 8, ["model-value"]))
}
}

})